<template>
  <div class="d-flex">

    <v-menu offset-y
            :close-on-content-click="false"
            v-model="menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" class="mr-2">
          Add
        </v-btn>
      </template>
      <v-list>
        <v-list-item
            v-for="(item, index) in itemsNotYetSelected"
            :key="index"
            link
            @click="addItem(item)"
        >
          <v-list-item-title>{{ item }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="itemsNotYetSelected.length === 0">
          <v-list-item-title>No Items Left</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <div class="drag-item-container" @click="menu = true">
      <draggable
          :list="localModel"
          ghost-class="ghost"
          draggable=".drag-item"
          @end="draggingFinished"
      >
        <v-chip v-for="val in localModel" :key="val"
                class="drag-item ma-1"
                close
                @click:close="remove(val)"
        >
          {{val}}
        </v-chip>
      </draggable>
    </div>

  </div>
</template>
<script>
import draggable from "vuedraggable";

export default {
  props: {
    model: {
      type: Array,
    },
    allOptions: {
      type: Array,
      required: true
    },
  },
  components: { draggable },
  data:()=>({
    menu: undefined
  }),
  computed: {
    localModel: {
      get() {
        if (!this.model) {
          return []
        }
        return [...this.model]
      },
      set(val) {
        this.$emit('update:model', val)
      },
    },
    itemsNotYetSelected() {
      if (!this.allOptions || this.allOptions.length === 0) {
        return []
      }
      if (!this.model || this.model.length ===0) {
        return this.allOptions
      }
      return this.allOptions
          .filter(item => {
            return !this.model.includes(item)
          })
    },
  },
  methods: {
    remove(val) {
      console.log('Removing ' + val);
      const index = this.localModel.indexOf(val)
      this.localModel.splice(index, 1)
      this.$emit('update:model', this.localModel)
    },
    addItem(val) {
      console.log('Adding ' + val);
      this.localModel.push(val)
      this.$emit('update:model', this.localModel)
    },
    draggingFinished() {
      this.$emit('update:model', this.localModel)
    },
  },
}
</script>
<style scoped lang="scss">
@import '~@/scss/variables';

.ghost {
  opacity: 0.3;
  background: $primary;
}

.handle {
  cursor: pointer;
}
.drag-item-container {
  width: 100%;
  border-bottom: 1px solid dimgrey;
  &:hover {
    border-bottom: 1.5px solid black;
  }

}

</style>
